
import React, {Component} from 'react'
import { connect } from 'react-redux'
import PageButtonFacade from './Button/PageButtonFacade.js'
import { PiArrowFatRightBold } from "react-icons/pi";
import { PiArrowFatLeftBold } from "react-icons/pi";

const themeUtil = require('../../utils/view/themeUtil.js');
const stateManager = require('../../utils/state/stateManager.js');
const layoutCurrentPageIndexAction = require('../../utils/state/actions/views/layout/layoutCurrentPageIndexAction.js');
const navigationHandler = require('./navigationHandler');
const cashFloatUtil = require('../../utils/domain/cashFloatUtil.js');

class PageBarView extends Component 
{
    render()
    {
        let pages = themeUtil.getResolvedPages();
        let pageIndex = this.props.layoutCurrentPageIndex;
        if (pageIndex < 0 || pageIndex >= pages.length)
            pageIndex = 0;

        let page = pages[pageIndex];
        
        var components = [];
        for (var index = 0; index < page.buttons.length; index++)
        {
            let button = themeUtil.getResolvedButton(page.buttons[index]);
            
            let marginLeft = index == 0 ? 'auto' : '30px';
            let marginRight = (index+1 == page.buttons.length) ? "auto": "0px";
            components.push(<PageButtonFacade onClick={()=>{navigationHandler.handleNavigationButtonOnClick(button)}} button={button} marginLeft={marginLeft} marginRight={marginRight}/>);
        }

        let nextPageComponent = null;
        if (pageIndex+1 < pages.length)
        {
            let onClick=()=>
            {
                stateManager.getStore().dispatch(layoutCurrentPageIndexAction.createAction(pageIndex+1));
            };

            nextPageComponent = <div onClick={onClick} style={{position:'fixed', right:'0px', marginRight:'10px'}}>
                                    <div style={{height: window.innerWidth*0.12}}>
                                            <div style={{position:'relative', top:'50%', left:'50%', transform:'translate(-50%, -50%)', textAlign:'center'}}>
                                                <div style={{paddingLeft:'10px', paddingRight:'10px'}}>
                                                    <PiArrowFatRightBold className='primary-color' size="5rem" opacity={0.1}/> 
                                                </div>
                                            </div>
                                        </div>
                                </div>
        }

        let previousPageComponent = null;
        if (pageIndex > 0)
        {
            let onClick=()=>
            {
                stateManager.getStore().dispatch(layoutCurrentPageIndexAction.createAction(pageIndex-1));
            };

            previousPageComponent = <div onClick={onClick} style={{position:'fixed', left:'0px', marginLeft:'10px'}}>
                                    <div style={{height: window.innerWidth*0.12}}>
                                            <div style={{position:'relative', top:'50%', left:'50%', transform:'translate(-50%, -50%)', textAlign:'center'}}>
                                                <div style={{paddingLeft:'10px', paddingRight:'10px'}}>
                                                    <PiArrowFatLeftBold className='primary-color' size="5rem" opacity={0.1}/> 
                                                </div>
                                            </div>
                                        </div>
                                </div>
        }

        return <div className="d-flex" style={{overflowX:'auto', width:Math.round(window.innerWidth * 0.99), marginBottom: '20vh'}}>
                    {previousPageComponent}
                    {components}
                    {nextPageComponent}
                </div>
    }
}

const mapStateToProps = state => 
{
    return { 
                layoutCurrentPageIndex: state.layoutCurrentPageIndex,
                currentStorefrontId: state.currentStorefrontId,
                cashFloatPayload: cashFloatUtil.getLoadedFloatSession()
           }
}

export default connect(mapStateToProps)(PageBarView)
